import { render } from "./CxAboutUs.vue?vue&type=template&id=0bddc48c&scoped=true"
const script = {}

import "./CxAboutUs.vue?vue&type=style&index=0&id=0bddc48c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bddc48c"]])

export default __exports__